import { createSlice } from "@reduxjs/toolkit";

const projectSlice = createSlice({
  name: "project",
  initialState: {
    activeProjectId: null,
    activeProjectName: null,
    activeProjectDescription: null,
    refreshProjects: false,
  },
  reducers: {
    setActiveProject: (state, action) => {
      state.activeProjectId = action.payload?.project_id ?? null;
      state.activeProjectName = action.payload?.name ?? null;
      state.activeProjectDescription = action.payload?.description ?? null;
    },
    clearActiveProject: (state) => {
      state.activeProjectId = null;
      state.activeProjectName = null;
      state.activeProjectDescription = null;
    },
    setRefreshProjects: (state, action) => {
      state.refreshProjects = action.payload;
    },
  },
});

export const { setActiveProject, clearActiveProject, setRefreshProjects } =
  projectSlice.actions;
export default projectSlice.reducer;